module.exports = __webpack_public_path__ + "img/icon-wm-1.f904fcab.svg";